import { StateCreator } from 'zustand'
import type { FFEStore } from '../types'
import type { FloorPlan, Shape } from '../../types/ffe'

export interface FloorPlansSlice {
  addFloorPlan: (
    name: string,
    type: FloorPlan['type'],
    imageUrl: string
  ) => void
  removeFloorPlan: (id: string) => void
  updateFloorPlan: (id: string, updates: Partial<FloorPlan>) => void
  addShape: (planId: string, shape: Omit<Shape, 'id'>) => void
  updateShape: (
    planId: string,
    shapeId: string,
    updates: Partial<Shape>
  ) => void
  removeShape: (planId: string, shapeId: string) => void
}

export const createFloorPlansSlice: StateCreator<
  FFEStore,
  [],
  [],
  FloorPlansSlice
> = (set) => ({
  addFloorPlan: (name, type, imageUrl) =>
    set((state) => ({
      document: {
        ...state.document,
        floorPlans: [
          ...state.document.floorPlans,
          {
            id: crypto.randomUUID(),
            name,
            type,
            imageUrl,
            shapes: []
          }
        ]
      }
    })),

  removeFloorPlan: (id) =>
    set((state) => ({
      document: {
        ...state.document,
        floorPlans: state.document.floorPlans.filter((plan) => plan.id !== id)
      }
    })),

  updateFloorPlan: (id, updates) =>
    set((state) => ({
      document: {
        ...state.document,
        floorPlans: state.document.floorPlans.map((plan) =>
          plan.id === id ? { ...plan, ...updates } : plan
        )
      }
    })),

  addShape: (planId, shape) =>
    set((state) => ({
      document: {
        ...state.document,
        floorPlans: state.document.floorPlans.map((plan) =>
          plan.id === planId
            ? {
                ...plan,
                shapes: [...plan.shapes, { ...shape, id: crypto.randomUUID() }]
              }
            : plan
        )
      }
    })),

  updateShape: (planId, shapeId, updates) =>
    set((state) => ({
      document: {
        ...state.document,
        floorPlans: state.document.floorPlans.map((plan) =>
          plan.id === planId
            ? {
                ...plan,
                shapes: plan.shapes.map((shape) =>
                  shape.id === shapeId ? { ...shape, ...updates } : shape
                )
              }
            : plan
        )
      }
    })),

  removeShape: (planId, shapeId) =>
    set((state) => ({
      document: {
        ...state.document,
        floorPlans: state.document.floorPlans.map((plan) =>
          plan.id === planId
            ? {
                ...plan,
                shapes: plan.shapes.filter((shape) => shape.id !== shapeId)
              }
            : plan
        )
      }
    }))
})
